let config;
export const setConfig = (params) => {
    if (config) {
        // eslint-disable-next-line no-console
        console.warn("Config was already set. If you see this message, there's likely a problem in how you setup the SDK.");
    }
    config = {
        ...params,
    };
    // cleanup on shutdown
    return () => {
        config = undefined;
    };
};
export const getConfig = () => {
    if (!config) {
        throw new Error('Config is not set. Call `setConfig(...)` first.');
    }
    return config;
};
export const isWorkspaceConfig = (config) => config.sdkType === 'workspace';
export const getWorkspaceConfig = () => {
    const config = getConfig();
    if (!isWorkspaceConfig(config)) {
        throw new Error('Expected workspace config, but got widget config.');
    }
    return config;
};
export const isWidgetConfig = (config) => config.sdkType === 'widget';
export const getWidgetConfig = () => {
    const config = getConfig();
    if (!isWidgetConfig(config)) {
        throw new Error('Expected widget config, but got workspace config.');
    }
    return config;
};
//# sourceMappingURL=config.js.map